import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@mui/material";

import {
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";

import { NavLink } from "react-router-dom";
import menuConfig from "../../config/menuConfig";
import { filterMenu } from "../../config/filterMenu";
export default function MobileDrawer({
  mobileOpen,
  setMobileOpen,
}) {
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (title) => {
    setOpenMenus((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };
 const user = JSON.parse(sessionStorage.getItem("user"));
//const roles = user?.role?.split(";") || [];

const roles =  user?.role?.includes(";")
  ? user?.role?.split(";").filter(Boolean)
  : user?.role?.split("").filter(Boolean);



  //console.log("rights", rights);

  
const menus = filterMenu(menuConfig, roles);
  return (
    <Drawer
      open={mobileOpen}
      onClose={() => setMobileOpen(false)}
      sx={{
        display: {
          md: "none",
        },
      }}
    >
      <List sx={{ width: 260 }}>
        {menus.map((item) => (
          <React.Fragment key={item.title}>
            {item.children ? (
              <>
                <ListItemButton
                  onClick={() => toggleMenu(item.title)}
                >
                  <ListItemIcon>
                    {item.icon}
                  </ListItemIcon>

                  <ListItemText primary={item.title} />

                  {openMenus[item.title] ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )}
                </ListItemButton>

                <Collapse
                  in={openMenus[item.title]}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.children.map((child) => (
                      <ListItemButton
                        key={child.title}
                        component={NavLink}
                        to={child.path}
                        state={child.state}
                        sx={{ pl: 4 }}
                        onClick={() =>
                          setMobileOpen(false)
                        }
                      >
                        <ListItemIcon>
                          {child.icon}
                        </ListItemIcon>

                        <ListItemText
                          primary={child.title}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              </>
            ) : (
              <ListItemButton
                component={NavLink}
                to={item.path}
                onClick={() => setMobileOpen(false)}
              >
                <ListItemIcon>
                  {item.icon}
                </ListItemIcon>

                <ListItemText
                  primary={item.title}
                />
              </ListItemButton>
            )}
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
}